/**
 * Configuration du système vocal
 */
export interface VoiceConfig {
  maxRecordingDuration: number;  // Durée max en secondes
  minConfidence: number;         // Seuil de confiance (0-1)
  language: string;              // Langue pour Whisper
  ttsVoice: TtsVoice;           // Voix TTS
  autoStopOnSilence: boolean;   // Stop auto après silence
  silenceThreshold: number;     // Seuil de silence (0-1)
  silenceDuration: number;      // Durée silence avant stop (ms)
}

/**
 * Voix disponibles pour OpenAI TTS
 */
export type TtsVoice = 'alloy' | 'echo' | 'fable' | 'onyx' | 'nova' | 'shimmer';

/**
 * Configuration par défaut
 */
export const DEFAULT_VOICE_CONFIG: VoiceConfig = {
  maxRecordingDuration: 60,          // 60 secondes max
  minConfidence: 0.7,
  language: 'fr',
  ttsVoice: 'nova',
  autoStopOnSilence: true,
  silenceThreshold: 0.02,            // Moins sensible au silence
  silenceDuration: 3000              // 3 secondes de silence avant stop
};
